export default function ManufacturerDTO(manufacturer) {
  var p = {};
  if (manufacturer) {
    p = {
      id: manufacturer.id,
      externalId: manufacturer.externalId,
      description:
        "[" + manufacturer.externalId + "]" + " " + manufacturer.description,
      hexadecimalManufacturerIdentifier:
        manufacturer.hexadecimalManufacturerIdentifier,
    };
  }
  return p;
}
